var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"flex","justify-content":"center","gap":"8px"}},[_c('span',[_vm._v("Game: "+_vm._s(_vm.gameId))]),(!_vm.copied)?_c('img',{staticStyle:{"cursor":"pointer"},attrs:{"src":require("@/assets/copy.png")},on:{"click":function($event){return _vm.copyGame()}}}):_c('img',{attrs:{"src":require("@/assets/check.png")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }